import { QueryInput } from '@/src/types/searchQuery'

export const getSearchQueryObj = (query: QueryInput) => {
    const {
        from,
        origin,
        sourceCountry,
        to,
        destination,
        destinationCountry,
        adults,
        childs,
        infants,
        depart_date,
        return_date,
        class: flightClass,
        intl,
        sd,
        airline,
        carrier
    } = query

    const queryObj: Record<string, string> = {
        from,
        to,
        origin,
        destination,
        depart_date,
        class: flightClass,
        adults,
        childs,
        infants,
        mobileApp: 'true',
        intl,
        responseType: 'jsonV3',
        // source: 'MOBILE',
        utm_currency: 'SAR',
        dc_enabled: 'true'
    }
    if (return_date) {
        queryObj.return_date = return_date
    }
    if (airline) {
        queryObj.airline = airline
    }
    if (carrier) {
        queryObj.carrier = carrier
    }
    if (sd) {
        queryObj.sd = sd
    }

    return queryObj
}
